import Cat1 from 'assets/white_category_icon_c1.svg';
import Cat2 from 'assets/white_category_icon_c2.svg';
import Cat3 from 'assets/white_category_icon_c3.svg';
import Cat4 from 'assets/white_category_icon_c4.svg';
import Cat5 from 'assets/white_category_icon_c5.svg';
import Cat6 from 'assets/white_category_icon_c6.svg';
import Cat7 from 'assets/white_category_icon_c7.svg';

export const categoryImgs = [Cat1, Cat2, Cat3, Cat4, Cat5, Cat6, Cat7];